import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  variant?: 'primary' | 'outline';
  fullWidth?: boolean;
  scrollToId?: string;
  href?: string;
}
export function Button({
  children,
  variant = 'primary',
  fullWidth = false,
  className = '',
  scrollToId,
  href,
  ...props
}: ButtonProps) {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (href) {
      window.open(href, '_blank', 'noopener,noreferrer');
    }
    if (scrollToId) {
      document.getElementById(scrollToId)?.scrollIntoView({
        behavior: 'smooth'
      });
    }
    props.onClick?.(e);
  };
  const baseStyles = 'relative inline-flex items-center justify-center px-8 py-4 font-heading text-lg uppercase tracking-wider font-bold transition-all duration-300 overflow-hidden rounded-sm';
  const variants = {
    primary: 'bg-gradient-to-r from-trading-gold to-trading-amber text-trading-dark hover:shadow-[0_0_20px_rgba(212,168,67,0.4)]',
    outline: 'border-2 border-trading-gold text-trading-gold hover:bg-trading-gold/10'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${widthClass} ${className}`} {...props} onClick={handleClick} data-id="element-232">
      {/* Shine effect overlay */}
      <div className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/30 to-transparent group-hover:animate-[shimmer_1.5s_infinite]" data-id="element-233" />
      <span className="relative z-10 flex items-center gap-2" data-id="element-234">{children}</span>
    </motion.button>;
}